import React from 'react';
import {Table, Loader, Icon, Popup, Button} from 'semantic-ui-react';
import moment from 'moment';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {Link} from 'react-router-dom';

export const AccesoriesRequestsTable = ({loading, accessoriesRequests, handleDetailsCard, selectedRequest}) => {
  const handleDetailsClick = (e, value) => {
    e.preventDefault();
    handleDetailsCard(value);
  };

  const style = {
    'row-selected': {
      'backgroundColor': 'yellow',
    },
  };

  return (
    loading ?
      <Table>
        <Table.Body>
          <Table.Row className='loader'>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table> :
      <Table striped className='dashboard-table'>
        <Table.Header className='orders-table-header'>
          <Table.Row>
            <Table.HeaderCell>Pedido</Table.HeaderCell>
            <Table.HeaderCell>Fecha Solicitud</Table.HeaderCell>
            <Table.HeaderCell>Solicitante</Table.HeaderCell>
            <Table.HeaderCell>Vehículos</Table.HeaderCell>
            <Table.HeaderCell>Despachado por</Table.HeaderCell>
            <Table.HeaderCell>Fecha Despacho</Table.HeaderCell>
            <Table.HeaderCell></Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {
            accessoriesRequests.map((accessoriesRequest, index) => {
              const selectedRow = selectedRequest === accessoriesRequest.request ? true : false;
              return <Table.Row key={index}
                style={selectedRow ? style['row-selected'] : null}>
                <Table.Cell>{accessoriesRequest.request}</Table.Cell>
                <Table.Cell>{moment(accessoriesRequest.request_date).format(reverseShortDate)}</Table.Cell>
                <Table.Cell>{accessoriesRequest.creation_user}</Table.Cell>
                <Table.Cell>
                  <Popup wide pinned inverted on='click'
                    trigger={<Link to=''>{accessoriesRequest.vehicles.length}</Link>}
                    content={accessoriesRequest.vehicles.map((chassis, i) => <div key={i}>{chassis}</div>)} />
                </Table.Cell>
                <Table.Cell>{accessoriesRequest.delivery_user ? accessoriesRequest.delivery_user : '-'}</Table.Cell>
                <Table.Cell>{accessoriesRequest.delivery_date ?
                  moment(accessoriesRequest.delivery_date).format(reverseShortDate) : '-'}</Table.Cell>
                <Table.Cell>
                  <Button icon onClick={(e) => handleDetailsClick(e, accessoriesRequest.request)} compact>
                    <Icon name={selectedRow ? 'eye-close' : 'eye'} size='big' link />
                  </Button>
                </Table.Cell>
              </Table.Row>;
            })
          }
        </Table.Body>
      </Table>
  );
};
